const initialstate = [];
const InfoEntrepriseReducer = (state = initialstate, action) => {
  if (action.type == "GET_INFO") {
    return action.payload;
  } else {
    return state;
  }
};
export default InfoEntrepriseReducer;
